module OnlineDPR.Application.Client.BwaOverview

open System

open Elmish
open Fable.React
open Fable.React.Props
open Fable.Import

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.DateHandling
open OnlineDPR.Application.Client
open OnlineDPR.Application.Client.Components

type Msg =
| ClubSelected of Field
| DateSelected of Field
| EditBwaRequested
| EditBwaResponded of Result<Result<EditRequestResult, string>, exn>

let logger = Jsnlog.GetLoggerWithName "BwaOverview"

let init () =
    let initField key fieldType value hideLabel label =
            Field.Init key fieldType (fun f -> { f with IsMandatory = false
                                                        Value = value
                                                        HideLabel = hideLabel
                                                        Label = Some label })

    let selectableMonths =
        let dateToSelectListItem (date:MonthDate) =
            { DisplayName = sprintf "%02i/%i" date.Month date.Year
              Value = MonthDateToJsString date}

        let start = new DateTime(2018,1,1)
        let now = DateTime.Now
        let months = Seq.initInfinite (fun i -> ( start.AddMonths(i) ))
        months |> Seq.takeWhile (fun d -> d <= now)
               |> Seq.toList
               |> List.rev
               |> List.map (fun d -> {Year = d.Year; Month = d.Month} )
               |> List.map dateToSelectListItem

    BwaOverviewModel { EditBwa = { ClubNumber = initField "club" FieldType.String "" false "Club-Nr."
                                   Date = initField "month" (FieldType.SelectOne { Items = selectableMonths }) selectableMonths.[0].Value false "Monat"
                                   ErrorMessage = None
                                   PendingRequest = false} } , []

let editBwaRequestCmd (data:EditBwaRequest) =
    Cmd.OfPromise.either(Http.postData APIUrls.PostAdminEditBwaRequest) data (Ok >> EditBwaResponded) (Error >> EditBwaResponded)

let validateEditRowFields (m:EditRowModel) =
    { m with
        ClubNumber = validateField m.ClubNumber
        Date = validateField m.Date }

let update msg model =
    match msg with
    | ClubSelected f -> { model with EditBwa = { model.EditBwa with ClubNumber = f; ErrorMessage = None } }, [ ]
    | DateSelected f -> let editBwa = validateEditRowFields { model.EditBwa with Date = f; ErrorMessage = None }
                        { model with EditBwa = editBwa }, [ ]
    | EditBwaRequested -> let model =  { model with EditBwa = validateEditRowFields model.EditBwa }
                          let validationMessage = List.tryFind (fun x -> Option.isSome x.ValidationMessage) [ model.EditBwa.ClubNumber; model.EditBwa.Date]
                          match validationMessage with
                          | Some _ -> model, []
                          | None -> { model with EditBwa = { model.EditBwa with PendingRequest = true } },
                                    let parsedDate = DateTime.Parse model.EditBwa.Date.Value
                                    (editBwaRequestCmd {
                                        ClubNumber = model.EditBwa.ClubNumber.Value;
                                        SelectedMonth = { Year = parsedDate.Year; Month = parsedDate.Month }})
    | EditBwaResponded r ->  match r with
                             | Ok ( Ok (EditRequestSuccess r)) ->
                                                    Browser.Dom.window.location.href <- r.Url
                                                    model, []
                             | Ok ( Ok (EditRequestError s)) ->
                                                    { model with EditBwa = { model.EditBwa with ErrorMessage = Some s } } , []
                             | Ok ( Ok _ ) -> model, []
                             | Ok ( Error s) ->
                                 logger.error s
                                 model, []
                             | Error e ->
                                 logger.error e
                                 model, []

let errorMessage s =
    [ span [ Class "has-error" ] [ str s] ]

let editDprError (m:EditRowModel) =
    match m.Date.ValidationMessage, m.ErrorMessage with
    | Some s, _ -> validationMessage s |> errorMessage
    | None, Some s -> errorMessage s
    | None, None -> []
    |> ofList

let view model dispatch =
    article [ Class "content" ]
            [ div [ Class "title-block" ]
                  [ h3 [ Class "title" ]
                       [ str "BWA Übersicht" ] ]
              section [ Class "section" ]

                      [ div [ ClassName "card card-default" ]
                            [ div [ ClassName "card-header" ]
                                  [ div [ ClassName "header-block" ]
                                        [ p [ ClassName "title" ]
                                            [ str "Download BWA" ] ] ]
                              div [ ClassName "card card-default" ]
                                  [ div [ ClassName "card-block" ]
                                        [ a [ Href PageUrls.bwaOverview
                                              ClassName "btn btn-info" ]
                                            [ str "Download" ] ] ] ]

                        div [ ClassName "card card-default" ]
                            [ div [ ClassName "card-header" ]
                                  [ div [ ClassName "header-block" ]
                                        [ p [ ClassName "title" ]
                                            [ str "BWA editieren" ] ] ]
                              div [ ClassName "card card-default card-editform" ]
                                  [ div [ ClassName "card-block" ]
                                        [ div [ ClassName "form-inline" ]
                                              [ InlineFormFieldComponent model.EditBwa.ClubNumber (ClubSelected >> dispatch)
                                                InlineFormFieldComponent model.EditBwa.Date (DateSelected >> dispatch)
                                                button [ Class "btn btn-primary"
                                                         OnClick (fun _ -> dispatch EditBwaRequested)]
                                                       [ str "Edit"]
                                                editDprError model.EditBwa ] ] ] ] ] ]